import { NetworkStatus } from '@cbridge-utils/network';
import { IAdjustmentRuleStore } from './adjustmentRule.interface';

export const adjustmentRuleInitialState: IAdjustmentRuleStore = {
  list: [],
  networkStatus: NetworkStatus.None,
};
